var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('h2',[_vm._v("Approval Dashboard")]),_c('v-spacer')],1),_c('v-row',{staticClass:"pt-7",attrs:{"no-gutters":""}},[_c('ApprovalNestedNavigation')],1),_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []

export { render, staticRenderFns }